import React from 'react';
import { Button } from 'react-admin';
import { Link } from 'react-router-dom';

import AddonSetIcon from '@material-ui/icons/LinearScale';
import { withStyles } from '@material-ui/core/styles';

const styles = {
	button: {
		marginTop: '1em'
	}
};

export const AddNewAddonSetButton = withStyles(styles)(({ classes, record }) => (
	<Button
		className={classes.button}
		variant="raised"
		component={Link}
		to={{
			pathname: '/productAddonSet/create',
			state: { record: { productId: record.id, active: true } }
		}}
		label="Add AddonSet"
	>
		<AddonSetIcon />
	</Button>
));